import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface IVideo {
  id: string;
  type: MESSAGES.VIDEO;
  videoId: string;
  rm: boolean;
  nodeId: string;
  avatar: boolean;
  role: ROLE.BOT;
}

export const createVideo = (data): IVideo => {
  return {
    id: data.id || uuid(),
    type: MESSAGES.VIDEO,
    videoId: data.videoId,
    rm: Boolean(data.rm),
    nodeId: data.nodeId,
    avatar: true,
    role: ROLE.BOT,
  };
};
